import React from "react";
import styled from "styled-components";
import SectionHeader from "../SectionHeader/SectionHeader";

/** Section de la page : en-tête + contenu */
const Section = ({ id, title, children }) => {
    return (
        <Wrapper id={id}>
            <SectionHeader sectionId={id} title={title} />
            {children}
        </Wrapper>
    );
};

export default Section;

const Wrapper = styled.section`
    margin-bottom: var(--prh-space-xl);
    scroll-margin-top: 80px;
`;
